export const environment = {
    AUTHPASS: btoa('test:test'),
    production: false,
    RELEASE_STAGE: 'staging',
    VERSION: require('../../../prva-prijava-skode/package.json').version,
    prva: {
        protocol: 'https://',
        rootUrl: 'test-app.eambulanta.si/api/booking',
        port: '',
        url: '/booking/asv2/prva/api',
    },
};
